export default __webpack_public_path__ + "static/media/filter-icon.cbea2437.svg";